<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">Announcement</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="
                    sessionStorage(search);
                    debounceInput();
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <v-btn class="primary" @click="openAddDialog">
                  <v-icon left>mdi-plus</v-icon>
                  Add Announcement
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="announcementData"
            :search="search"
            :options.sync="options"
            :server-items-length="totalRecords"
            :loading="loading"
            :page.sync="page"
          >
              <template v-slot:item.title="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.title }}
                </div>
              </template>
              <template v-slot:item.date="{ item }">
                {{ getFormattedDate(item.created_at) }}
              </template>
              <template v-slot:item.member="{ item }">
                <span v-if="item.contact_person_name">
                  {{ item.contact_person_name }}
                </span>
                <span v-else>{{ item.name }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="secondary"
                  icon
                  style="margin-left: -10px"
                  @click="openEditDialog(item)"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_announcement"
                  title="Delete Announcement"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="addDialogBox" max-width="450" @click:outside="closeDialog">
        <v-card>
          <v-card-title class="text-h5">
            {{ committee.id ? "Edit" : "Add" }} Announcement
          </v-card-title>
          <v-card-text class="pa-5">
          
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="committee.title"
                  name="title"
                  id="title"
                  label="Message"
                  v-validate="'required'"
                  data-vv-as="Message"
                  :error="errors.first('title') != null || serverSideErrors.title != null"
                  :error-messages="errors.first('title') || serverSideErrors.title"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">cancel</v-btn>
            <v-btn color="blue darken-1" text @click="saveAnnouncement" v-if="!committee.id">
              save
            </v-btn>
            <v-btn color="blue darken-1" text @click="updateAnnouncement(committee.id)" v-else>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">Confirm!!</v-card-title>
          <v-card-text class="mt-2">Are you sure you want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteAnnouncement(delete_id)">yes</v-btn>
            <v-btn color="primary" text @click="closeDialog">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
      {
          text: `${this.$t("notice.headers.title")}`,
          value: "title",
          width: "25%",

        },
        {
          text: `${this.$t("committee.headers.member")}`,
          value: "member",
          width: "30%",

        },
        {
          text: "Date",
          value: "date",
          width: "25%",
        },
        
        {
          text: `${this.$t("committee.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "15%",

        },
      ],
      user: {},
      addDialogBox: false,
      deleteDialog: false,
      menu: false,
      members: [],
      announcementData: [],
      serverSideErrors: [],
      delete_id: "",
      selected_type: "flat",
      flats: [],
      committee: {
        title: "",
      },
      options: {
        sortBy: ["created_at"],
      },
      totalRecords: 0,
      loading: false,
      page: 1,
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getData() {
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc = this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      this.$axios
        .get(
          "societyadmin/announcement" +
            "?page=" +
            page +
            "&perPage=" +
            itemsPerPage +
            "&sortBy=" +
            sortBy +
            "&sortDesc=" +
            sortDesc +
            "&search=" +
            search
        )
        .then((response) => {
          this.loading = false;
          let data = response.data;
          if (data.status) {
            this.announcementData = data.data;
            this.totalRecords = data.total;
            this.page = data.page > data.lastPage ? 1 : data.page;
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              this.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    deleteAnnouncement(memberId) {
      this.$axios.delete("societyadmin/announcement/" + memberId).then((response) => {
        let data = response.data;
        if (data.status) {
          this.confirmDelete();
          this.getData();
          this.closeDialog();
          this.setAlert({
            showAlert: true,
            variant: "green accent-4",
            timeout: "2000",
            message: data.message,
          });
        } else {
          this.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    saveAnnouncement() {
     
      this.$validator.validateAll().then((success) => {
        console.log(this.committee)
        if (success) {
          this.$axios.post("/societyadmin/announcement", this.committee).then((response) => {
            let data = response.data;
            if (data.status) {
              this.setAlert({
                showAlert: true,
                message: data.message,
                variant: "green accent-4",
                timeout: 2000,
              });
              this.getData();
              this.closeDialog();
            } else {
              this.handleErrors(data.errors, data.message);
            }
          });
        }
      });
    },
    updateAnnouncement(id) {
      this.$validator.validateAll().then((success) => {
        if (success) {
          this.$axios.put("/societyadmin/announcement/" + id, this.committee).then((response) => {
            let data = response.data;
            if (data.status) {
              this.setAlert({
                showAlert: true,
                message: data.message,
                variant: "green accent-4",
                timeout: 2000,
              });
              this.getData();
              this.closeDialog();
            } else {
              this.handleErrors(data.errors, data.message);
            }
          });
        }
      });
    },
    openAddDialog() {
      this.addDialogBox = true;
      this.committee = {};
    },
    openEditDialog(item) {
      this.addDialogBox = true;
      this.committee.id = item.id;
      this.committee.title = item.title;
    },
    confirmDelete(id) {
      this.deleteDialog = true;
      this.delete_id = id;
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("announcement_search");
      } else {
        const trimmedSearch = search.trim();
        this.search = trimmedSearch;
        sessionStorage.setItem("announcement_search", trimmedSearch);
      }
    },
    closeDialog() {
      this.deleteDialog = false;
      this.addDialogBox = false;
      this.committee = {};
      this.$validator.reset();
      this.serverSideErrors = [];
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    debounceInput: debounce(function () {
      this.getData();
    }, 500),
    handleErrors(errors, message) {
      if (errors) {
        this.serverSideErrors = {};
        for (let i = 0; i < errors.length; i++) {
          this.serverSideErrors[errors[i].field] = errors[i].message;
        }
      } else {
        this.setAlert({
          showAlert: true,
          variant: "red accent-3",
          timeout: "2000",
          message: message,
        });
      }
    },
  },
  mounted() {
    this.user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};
    this.search = sessionStorage.getItem("announcement_search");
  },
};
</script>
